import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'components/Button';

import './style.scss';

export default class InspectTab extends Component {
  static propTypes = {
    tab: PropTypes.shape({
      tabIndex: PropTypes.number,
      label: PropTypes.string,
      hasWarning: PropTypes.bool,
    }),
    selectedTab: PropTypes.number,
    changeTab: PropTypes.func,
  };

  handleChangeTab = () => this.props.changeTab(this.props.tab.tabIndex);

  render() {
    const {
      tab: { tabIndex, label, hasWarning },
      selectedTab,
    } = this.props;

    return (
      <Button
        isLink
        onClick={this.handleChangeTab}
        styleName={classnames('tab link', {
          'is-active': selectedTab === tabIndex,
          'is-warning': hasWarning,
        })}
        data-test={`${label}-tab`}
      >
        {label}
      </Button>
    );
  }
}
